import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-FixedIncomeCashFlowFilter',
    templateUrl: './dojo-FixedIncomeCashFlowFilter.component.html'
})
export class DojoFixedIncomeCashFilter implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: string;
    currYear: string;
    nextYear: string;
    year: string;
    hasError: boolean;
    hasData: boolean;
    isProcessed: boolean;
    isCurrSelected: boolean = false;
    isNextSelected: boolean = false;
    ismobile: boolean = false;
    deviceType: string = '';
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private router: Router,
                @Optional() @Inject('AppSettings') appSettings: any) {
                    if ( appSettings ) {
                        this.deviceType = appSettings.deviceType;
                    }
                    if (appSettings.deviceType === 'mobile') {
                        this.ismobile = true;
                     }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            if (this.inputValue !== '' && this.acctRef !== 'undefined') {
                this.getDojoFICashFlowSummary();
                // this.getDojoFixedIncomeCashFlow();
            }
        });
    }

    ngOnDestroy(): void {
        console.log('In destroyDojoFixedIncomeCashFlow destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyDojoFixedIncomeCashFlow();
        }
    }
    getDojoFixedIncomeCashFlow(value: string) {
        this.resetFlags();
        if (value === '1') {
            this.year = this.currYear;
            this.isCurrSelected = true;
            this.isNextSelected = false;
        } else {
            this.year = this.nextYear;
            this.isNextSelected = true;
            this.isCurrSelected = false;
        }
        this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'fixedIncomeCashFilter').subscribe(
            resp => {
                console.log('Retrived common REST FixedIncomeCash params : ', resp.response);
                if (resp.response) {
                    this.isProcessed = true;
                    this.hasData = true;
                    resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                    resp.response.nxiRestBaseUrl = this.nxiRestService.serviceUrl;
                    resp.response.year = this.year;
                    if (dojoApp) {
                        // pass necessary parameters to render dojo widgets
                        dojoApp.renderDojoFixedIncomeCashFilter(resp.response);
                    }
                } else {
                    this.handleError(false);
                }
            },
            error => {
                this.handleError(true);
            }
        );
    }

    getDojoFICashFlowSummary() {
        this.resetFlags();
        this.currYear = null;
        this.nextYear = null;
        this.nxiRestService.getNxiPortfolioRestResponse(this.acctRef, 'fiCshFlw/summary?reportType=1&isGDR=true').subscribe(
            resp => {
                console.log('Retrived REST FICash summary for rendering at first : ', resp);
                if (resp && resp.fiCshFlwSummary && resp.fiCshFlwSummary.length > 0) {
                    this.currYear = resp.fiCshFlwSummary[0].fundPaymentDate;
                    if (resp.fiCshFlwSummary.length > 1) {
                        this.nextYear = resp.fiCshFlwSummary[1].fundPaymentDate;
                    }
                    this.getDojoFixedIncomeCashFlow('1');
                } else {
                    this.renderDownloadLinks();
                    this.handleError(false);
                }
            },
            error => {
                this.handleError(true);
            }
        );
    }
    renderDownloadLinks() {
        dojoApp.renderFixedIncomeCashFlowDownLoadLinks(this.nxiRestService.serviceUrl + '/portfolio/' + this.acctRef + '/fiCshFlw/summary');
    }

    handleError(hasError: boolean) {
        this.hasData = false;
        this.hasError = hasError;
        this.isProcessed = true;
        dojoApp.destroyDojoFixedIncomeCashFlow();
    }
    resetFlags() {
        this.hasData = false;
        this.hasError = false;
        this.isProcessed = false;
    }
}
